import Vue from 'vue/dist/vue.esm'
import template from './historical_score_card_template.slim'

Vue.component('historical_score_card', {
  mixins: [template],
  props: [
    'score',
    'score_band',
    'score_colors_and_fills'
  ],
  computed: {
    scoreColorIndex() {
      const indexMap = { 'Not Yet': 0, 'Somewhat': 1, 'Mostly': 2, 'Yes': 3, 'Exemplary': 4 };
      return indexMap[this.score.display];
    },
    scoreColorAndFill() {
      return this.score_colors_and_fills && this.scoreColorIndex != null ? { color: this.score_colors_and_fills[this.scoreColorIndex].color, fill: this.score_colors_and_fills[this.scoreColorIndex].fill } : { color: "#D1D8E3", fill: 0 };
    },
  },
})
